import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'emptyDash'
})
export class EmptyDashPipe implements PipeTransform {
	transform(value: string | number | null | undefined, ignore?: string): string | number {
		try {
			// Normalize null/undefined/empty
			if (value === null || value === undefined || value === '') {
				return '--';
			}

			// If value is a number, convert to string for trimming but preserve numeric return
			const isNumber = typeof value === 'number';
			let str = String(value);

			// If an ignore string was provided and is non-empty, build a safe RegExp
			if (ignore && typeof ignore === 'string' && ignore.trim().length > 0) {
				// Escape regex-special characters in the ignore string
				// eslint-disable-next-line no-useless-escape
				const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&');
				const pattern = escapeRegExp(ignore);
				str = str.replace(new RegExp(pattern, 'ig'), '').trim();
				if (str === '') {
					return '--';
				}
				return isNumber ? Number(str) : str;
			}

			// No ignore provided — just trim and return
			str = str.trim();
			if (str === '') {
				return '--';
			}
			return isNumber ? Number(str) : str;
		} catch (err) {
			// On unexpected errors, return a safe fallback
			if (value === null || value === undefined || value === '') {
				return '--';
			}
			const v = String(value).trim();
			if (v === '') {
				return '--';
			}
			return v;
		}
	}
}
